import { cn } from "@/lib/utils";
import { isNil } from "lodash";
import { ReactNode } from "react";
import { Skeleton } from "@/components/ui/skeleton";

type RevenueCardProps = {
  icon?: ReactNode;
  title: ReactNode;
  subTitle?: ReactNode;
  trend?: ReactNode;
  className?: string;
  description?: ReactNode;
};
export const RevenueCard = ({ icon, title, subTitle, trend, className, description }: RevenueCardProps) => {
  return (
    <div className={cn("w-[16.75rem] h-[107px] rounded-2xl border border-icon py-7 px-8 bg-white", className)}>
      <div className="flex flex-col justify-between items-center">
        <div className="flex items-center">
          {icon && (
            <div className="size-5 rounded-full  flex items-center justify-center mr-1.5 icon-secondary">{icon}</div>
          )}
          <span className="uppercase text-muted-foreground text-xs font-extrabold">{title}</span>
        </div>
        {!isNil(subTitle) && (
          <div className="flex items-center mt-1.5">
            <span className="font-black text-primary text-xl leading-6 mr-2">{subTitle}</span>
            {trend}
          </div>
        )}
        {!isNil(description) && <div className="text-secondary text-xs font-bold">{description}</div>}
      </div>
    </div>
  );
};

export const RevenueCardSkeleton = () => {
  return (
    <div className="w-[16.75rem] h-[107px] rounded-2xl border border-icon bg-white p-2">
      <Skeleton className="h-full w-full" />
    </div>
  );
};
